import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { IEditPhoneCenterForm, IPostEditPhoneCenter } from '../phoneCenter';


const mapPhoneCenterToApiPhoneCenterDto = (values: IEditPhoneCenterForm): IPostEditPhoneCenter | {} => {
  let dataMapping: IPostEditPhoneCenter;

  if (values.providers == undefined){return {}}

    dataMapping = {
      description: values.description,    
      phoneCentersSysModelId: +values.phoneCentersSysModelId,
      phoneCentersMaintenanceId: +values.phoneCentersMaintenanceId,
      unitID: +values.unitID,
      incomingLines: values.incomingLines,
      outgoingLines: values.outgoingLines,
      channelNumber: values.channelNumber,
      workstaions: values.workstaions,
      elevatorNumber: values.elevatorNumber,
      fctNumber:values.fctNumber,
      errorCode:values.errorCode,
      internalsNumber:values.internalsNumber,
      comments:values.comments,
      fileLink:values.fileLink,
      isPSTN: values.isPSTN,
      isISDN: values.isISDN,
      is30PRI: values.is30PRI,
      isLine: values.isLine,
      providers: values.providers.map(provider => Number(provider.value))
    }
  
  return dataMapping;
}


const editPhoneCenter = ( {data, PhoneCenterId} : {data: IEditPhoneCenterForm , PhoneCenterId: number}): Promise<string> => {
  const PhoneCenter = mapPhoneCenterToApiPhoneCenterDto(data);
  return axiosDefaultApi.put(`/api/PhoneCenters/UpdatePhoneCenter/${PhoneCenterId}`, PhoneCenter);
};

type QueryFnType = typeof editPhoneCenter;

type UseEditPhoneCenterOptions = {
  data: IPostEditPhoneCenter | {};
  PhoneCenterId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditPhoneCenter = ({ config }: UseEditPhoneCenterOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Τηλεφωνικού Κέντρου.`, 500);
            console.error('Couldnt edit PhoneCenter', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhoneCenters"])
            addNotification('Το Τηλεφωνικό Κέντρο Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editPhoneCenter,
    })
}